var LabelConstants = /** @class */ (function () {
    function LabelConstants() {
    }
    LabelConstants.TRIAL_PLAY_SPORTS_LABEL_FALL_BACK = 'play.sports.day.pass'; // TODO the label for playsports trial was wrong at Café, as soon as they fix it we have to fix it here as well
    LabelConstants.TRIAL_PLAY_SPORTS_LABEL = 'play.sports.trial';
    LabelConstants.TRIAL_PLAY_75_DAYS_LABEL = 'play.trial.75_days';
    LabelConstants.TRIAL_PLAY_30_DAYS_LABEL = 'play.trial.30_days';
    LabelConstants.TRIAL_PLAY_MORE_30_DAYS_LABEL = 'playmore.trial.30_days';
    LabelConstants.TRIAL_PLAY_MORE_75_DAYS_LABEL = 'playmore.trial.75_days';
    LabelConstants.TERMS_AND_CONDITIONS_TITLE = 'eos-tv-shop-ii.lbl.terms-and-conditions';
    LabelConstants.LABEL_TRIAL_MAP = new Map([[null, null]]);
    return LabelConstants;
}());
export { LabelConstants };
